import { render, staticRenderFns } from "./AffiliatesBanner.vue?vue&type=template&id=a13416b2&scoped=true"
import script from "./AffiliatesBanner.vue?vue&type=script&lang=js"
export * from "./AffiliatesBanner.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesBanner.vue?vue&type=style&index=0&id=a13416b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13416b2",
  null
  
)

export default component.exports